import { BASE_URL, CONFIG } from 'src/common/config'
import emitter from 'src/services/event-emitter'
import { TokenService } from 'src/common/token-service'

let socket = null
let timer = null
let wsIntervalReconnect = CONFIG.WS.WS_INTERVAL_RECONNECT

const tokenService = new TokenService()

function listenSocket(e) {
  const { text } = JSON.parse(e.data)
  const { message_type, content } = text

  emitter.emit(message_type, content)
}

function handleOpen() {
  const token = tokenService.getToken()
  if (token) {
    sendMessage({
      action: 'update_token',
      content: token,
    })
  }

  keepConnectionAlive()
}

async function keepConnectionAlive() {
  try {
    while (socket && socket.readyState === WebSocket.OPEN) {
      await sendPing()
      await new Promise((resolve) => setTimeout(resolve, CONFIG.WS.PONG_INTERVAL))
    }
  } catch {
    console.error('Error or ping timeout, closing socket')
    if (socket) {
      socket.close()
    }
  }
}

function sendPing() {
  return new Promise((resolve, reject) => {
    sendMessage({ action: 'ping' })

    const timeout = setTimeout(() => {
      wsIntervalReconnect = 0
      reject(new Error('Pong timeout'))
    }, CONFIG.WS.PONG_TIMEOUT)

    const onMessage = (event) => {
      const { text } = JSON.parse(event.data)
      if (text.message_type === 'pong') {
        clearTimeout(timeout)
        socket.removeEventListener('message', onMessage)
        resolve()
      }
    }

    socket.addEventListener('message', onMessage)
  })
}

function reconnect() {
  socket = null
  clearTimeout(timer)

  timer = setTimeout(() => connectToWs(), wsIntervalReconnect)
}

export function connectToWs() {
  if (socket && socket.readyState === WebSocket.OPEN) {
    return
  }

  wsIntervalReconnect = CONFIG.WS.WS_INTERVAL_RECONNECT

  const urlWs = process.env.WS_DOMAIN || `wss://${location.hostname}${BASE_URL}/api/g/ws/`
  socket = new WebSocket(urlWs)

  socket.onopen = handleOpen
  socket.onmessage = listenSocket
  socket.onclose = reconnect
  socket.onerror = reconnect
}

export function sendMessage(json) {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(json))
  }
}
